import { Link } from "react-router";

import { Eye } from "lucide-react";

import { Button } from "@/components/ui/button";

interface OpenRowButtonProps {
  to: string;
  /** What the button opens, for a screen reader: the button is an icon alone. */
  label: string;
}

/**
 * The eye button of a row's Actions column, drawn as `ShowButton size="sm" hideText` draws it on the HITL queue.
 *
 * `ShowButton` finds its target from the resource's `show` route, and the festival card and record pages are plain
 * routes that no resource names, so it would link nowhere. The path is known here, so it is passed in. A real link,
 * like `ShowButton`'s, so a middle click or a new-tab click works.
 */
export const OpenRowButton = ({ to, label }: OpenRowButtonProps) => (
  <Button size="sm" asChild>
    <Link to={to} aria-label={label}>
      <Eye className="h-4 w-4" />
    </Link>
  </Button>
);
